var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignal4Of5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.439,
    height: 26.107,
    viewBox: "0 0 33.439 26.107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14207",
    "data-name": "Group 14207",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38478",
    "data-name": "Path 38478",
    d: "M562.652,830.8a2.781,2.781,0,1,1,2.781-2.781,2.784,2.784,0,0,1-2.781,2.781",
    transform: "translate(-545.932 -804.689)",
    fill: "#fdd612"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38479",
    "data-name": "Path 38479",
    d: "M1.992,9.888A1.992,1.992,0,0,1,.616,6.455a23.326,23.326,0,0,1,32.206,0,1.992,1.992,0,0,1-2.751,2.882,19.342,19.342,0,0,0-26.7,0,1.983,1.983,0,0,1-1.375.551",
    transform: "translate(0 -0.005)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38480",
    "data-name": "Path 38480",
    d: "M215.614,288.661a1.983,1.983,0,0,1-1.375-.551,12.353,12.353,0,0,0-17.055,0,1.992,1.992,0,0,1-2.751-2.882,16.337,16.337,0,0,1,22.557,0,1.992,1.992,0,0,1-1.376,3.433",
    transform: "translate(-188.991 -273.721)",
    fill: "#fdd612"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38481",
    "data-name": "Path 38481",
    d: "M395.906,561.622a1.983,1.983,0,0,1-1.375-.551,5.51,5.51,0,0,0-7.608,0,1.992,1.992,0,1,1-2.751-2.882,9.494,9.494,0,0,1,13.109,0,1.992,1.992,0,0,1-1.376,3.433",
    transform: "translate(-374.008 -541.732)",
    fill: "#fdd612"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignal4Of5);
export default __webpack_public_path__ + "static/media/signal 4 of 5.fbcb23f4d98ff0d765b540b333c5a01b.svg";
export { ForwardRef as ReactComponent };